import { useTranslation } from 'next-i18next';
import { BoltSmallRectangleColorVioletIcon } from '@/icons';
import { usePrices } from '@/module/payment/hooks';
import { useCountryCode } from '@/shared/hooks';
import { useFirstPurchaseDiscount } from '@/shared/hooks/useFirstPurchaseDiscount';
import { useFeatureStrings } from '@/shared/plan/useFeatureStrings';
import { Button } from '@/ui_v3';
import { cn } from '@/utils';
import * as PricingCard from './PricingCard';
export const ProPricingCard = (props: PricingCard.PricingCardProps) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    className,
    ctaButtonText: ctaButtonTextProp,
    ctaButtonDisabled,
    onCtaButtonClick,
    footer
  } = props;
  const ctaButtonText = ctaButtonTextProp ?? t('common:pricing.pro.purchase');
  const {
    countryCode
  } = useCountryCode();
  const {
    displayOriginalPrice: proOriginalPrice,
    displayFinalPrice: proFinalPrice,
    displayCurrency,
    discountRate
  } = usePrices({
    countryCode,
    planType: 'PRO'
  });
  const featureStrings = useFeatureStrings(countryCode);
  const {
    isEligible: hasBasicPromotion
  } = useFirstPurchaseDiscount();
  return <PricingCard.Container className={cn(!hasBasicPromotion && 'p-[2px] border-0 bg-gradient-violet-blue !shadow-[0px_3px_6px_0px_rgba(103,88,255,0.12),0px_0px_10px_0px_rgba(103,88,255,0.5)]', className)} data-sentry-element="unknown" data-sentry-component="ProPricingCard" data-sentry-source-file="ProPricingCard.tsx">
      <PricingCard.TopSection data-sentry-element="unknown" data-sentry-source-file="ProPricingCard.tsx">
        <PricingCard.Header data-sentry-element="unknown" data-sentry-source-file="ProPricingCard.tsx">
          <div className="flex w-full flex-wrap items-center justify-between gap-y-sm">
            <div className="flex items-center gap-2xs">
              <BoltSmallRectangleColorVioletIcon size="xl" data-sentry-element="BoltSmallRectangleColorVioletIcon" data-sentry-source-file="ProPricingCard.tsx" />
              <h2 className="text-heading-xl-extrabold">Pro</h2>
            </div>
            <div className="rounded-sm bg-gradient-to-r from-violet-400/20 to-blue-400/20 px-sm py-3xs text-body-md-semibold text-strong">
              {t('pricing.pro.popularChoice')}
            </div>
          </div>
        </PricingCard.Header>
        <PricingCard.PaidPlanPrice listPrice={proOriginalPrice} finalPrice={proFinalPrice} currency={displayCurrency} discountRate={discountRate} priceClassName={!hasBasicPromotion ? 'bg-clip-text text-transparent bg-gradient-to-r from-violet-400 to-blue-400' : 'mt-[24px]'} data-sentry-element="unknown" data-sentry-source-file="ProPricingCard.tsx" />
        <PricingCard.Description data-sentry-element="unknown" data-sentry-source-file="ProPricingCard.tsx">
          {t('common:pricing.pro.description')}
        </PricingCard.Description>
        <Button intent={!hasBasicPromotion ? 'gradient' : 'alternative'} size="lg" className="mt-auto w-full" disabled={ctaButtonDisabled} onClick={onCtaButtonClick} data-sentry-element="Button" data-sentry-source-file="ProPricingCard.tsx">
          {ctaButtonText}
        </Button>
      </PricingCard.TopSection>

      <PricingCard.Divider data-sentry-element="unknown" data-sentry-source-file="ProPricingCard.tsx" />

      <PricingCard.BottomSection data-sentry-element="unknown" data-sentry-source-file="ProPricingCard.tsx">
        <PricingCard.FeatureTitles mainTitle={t('common:pricing.pro.usefulFeatures')} subTitle={t('common:pricing.pro.includesAllFeatures', {
        plans: 'Free, Basic'
      })} data-sentry-element="unknown" data-sentry-source-file="ProPricingCard.tsx" />
        <PricingCard.FeatureItemList items={featureStrings.PRO.normalFeatures} data-sentry-element="unknown" data-sentry-source-file="ProPricingCard.tsx" />
        <PricingCard.AiFeatureItemList title={t('common:pricing.pro.enhancedQuizAI')} items={featureStrings.PRO.aiFeatures} data-sentry-element="unknown" data-sentry-source-file="ProPricingCard.tsx" />
      </PricingCard.BottomSection>
      {footer}
    </PricingCard.Container>;
};